import {createApp, reactive} from "vue";
import App from "./App.vue";
import "./index.css";

let app = createApp(App);
app.config.globalProperties.$kot = reactive({login: true});
app.mount("#app");
